// extracted by mini-css-extract-plugin
module.exports = {"productBorder":"ProductList_productBorder__1Aimq"};